import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import "firebase/compat/auth";
import "firebase/compat/firestore";

const firebaseConfig = { "apiKey": "AIzaSyCIqCyO4JS8p6IUIYHLJZcZ6byF69gCqiI", "authDomain": "prod-self-service.firebaseapp.com", "databaseURL": "https://prod-self-service-default-rtdb.firebaseio.com", "projectId": "prod-self-service", "storageBucket": "prod-self-service.appspot.com", "messagingSenderId": "1071227001059", "appId": "1:1071227001059:web:3bec904c162da9f9884dd6", "measurementId": "G-ZEFMYDS0G1" };

const firebaseApp = initializeApp(firebaseConfig);

export const db = getFirestore(firebaseApp);
export const auth = getAuth(firebaseApp);
export { firebaseApp };
